import * as React from 'react';

// PACKAGES
import { CSSTransition } from 'react-transition-group';

// ICON
import { ReactComponent as SpinnerIcon } from '../assets/svg/spinner.svg';

interface LoadingSpinnerTypes {
	show: boolean;
	isStatic?: boolean;
	width?: number;
	height?: number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerTypes> = ({ show = false, isStatic = false, width, height }) => {
	return (
		<CSSTransition
			in={show}
			timeout={{
				enter: 1600,
				exit: 600
			}}
			classNames="spinner-fade"
			appear
		>
			<div className={`loading-spinner ${isStatic ? 'static' : ''}`}>
				<SpinnerIcon width={width} height={height} />
			</div>
		</CSSTransition>
	);
};

export default LoadingSpinner;
